<ul>
  <ng-container *ngFor="let error of _errors">
    <li class="gap-1">{{ error.message | transloco }}:
      <div class="sequence-error mb-2">
        <span class="ml-3"> {{ 'error.sequences.configuration.path' |transloco }}: {{ error.path }}</span>
        <ngx-json-viewer [expanded]="false" [json]="error.json"></ngx-json-viewer>
      </div>
    </li>
  </ng-container>
</ul>
